var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 5H4C3.4 5 3 5.4 3 6V18C3 18.6 3.4 19 4 19H26C26.6 19 27 18.6 27 18V6C27 5.4 26.6 5 26 5ZM5.5 14C5.3 14 5.1 14 5 14.1V9.9C5.1 10 5.3 10 5.5 10C6.9 10 8 8.9 8 7.5C8 7.3 8 7.1 7.9 7H22C22 7.1 22 7.3 22 7.5C22 8.9 23.1 10 24.5 10C24.7 10 24.9 10 25 9.9V14C24.9 14 24.7 13.9 24.5 13.9C23.1 13.9 22 15 22 16.4C22 16.6 22 16.8 22.1 16.9H7.9C8 16.9 8 16.7 8 16.5C8 15.1 6.9 14 5.5 14ZM12 12C12 10.3 13.3 9 15 9C16.7 9 18 10.3 18 12C18 13.7 16.7 15 15 15C13.3 15 12 13.7 12 12ZM5 22V21H25V22C25 22.6 24.6 23 24 23H6C5.4 23 5 22.6 5 22ZM7.4 26V25H22.4V26C22.4 26.6 22 27 21.4 27H8.4C7.8 27 7.4 26.6 7.4 26Z",
    fill: "var(--tg-theme-accent-text-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.44348cb3e8ba28720a914e5393cdde5c.svg";
export { ForwardRef as ReactComponent };